// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__UmQX_","label":"styles_label__RGF9H","itemList":"styles_itemList___V5jQ","item":"styles_item__YdgQ9"};